<template>
  <div class="button-dialog-wrapper">
    <button v-if="canShowBtn()" :class="['button primary openDialog', addingClass]"
            :disabled="isProcessing()"
            @click="openDialog"
            @keydown.27="closeDialog">
      Chcę poznać ofertę <i class="el-icon-loading" v-if="isProcessing()"></i>
    </button>
    <a v-if="!canShowBtn() && !showOnlyWithHash"  :class="['button primary', addingClass]" href="https://www.brutto.pl/" target="_blank" rel="noopener noreferrer" aria-label="Chcę poznać ofertę finansowania brutto.pl">Chcę poznać ofertę</a>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'ButtonOpenDialog',
  props: ['addingClass', 'showOnlyWithHash'],
  data () {
    return {
      isHash: this.$route.params.hash,
      btnClicked: false
    }
  },
  methods: {
    ...mapMutations([
      'SET_DIALOG_ACTIVE'
    ]),
    isProcessing () {
      return this.isLoading && this.btnClicked
    },
    isDataSet () {
      return new Promise((resolve) => {
        const handler = setInterval(() => {
          if (!this.isLoading) {
            clearInterval(handler)
            resolve()
          }
        }, 100)
      })
    },
    async openDialog () {
      this.btnClicked = true
      if (this.isLoading) {
        await this.isDataSet()
      }
      this.SET_DIALOG_ACTIVE(true)
    },
    closeDialog () {
      this.btnClicked = false
      this.SET_DIALOG_ACTIVE(false)
    },
    canShowBtn () {
      return this.isHash && !this.isHashError && !this.isLoading
    }
  },
  computed: {
    ...mapState({
      isHashError: state => state.agreements.isHashError,
      isLoading: state => state.agreements.isLoading
    })
  }
}
</script>
